import { isSameIdentifier } from 'ts/commons/code/CodeToken.focus';
import { useRenderedCodeOptions } from 'ts/commons/code/RenderedCode.context';
import type { LineSegment } from 'ts/commons/code/RenderedCode.segments';
import type { ELanguage } from 'typedefs/ELanguage';

/** Handles the highlighting of parameters from a refactoring suggestion: Input and Return parameters. */
export function useCodeTokenRefactoringSuggestion(segment: LineSegment): {
	isInputParameter: boolean;
	isReturnParameter: boolean;
	title: string | undefined;
} {
	const { language, highlightedRefactoringSuggestion } = useRenderedCodeOptions();
	const isInputParameter = isEntityMatched(highlightedRefactoringSuggestion?.inputParameters, segment, language);
	const isReturnParameter = isEntityMatched(highlightedRefactoringSuggestion?.returnParameters, segment, language);
	let title;
	if (isInputParameter && isReturnParameter) {
		title = 'Input and return parameter';
	} else if (isInputParameter) {
		title = 'Input parameter';
	} else if (isReturnParameter) {
		title = 'Return parameter';
	}
	return { isInputParameter, isReturnParameter, title };
}

function isEntityMatched(parameters: string[] | undefined, segment: LineSegment, language: ELanguage | undefined) {
	return parameters?.some(parameter => isSameIdentifier(parameter, segment.text, language)) ?? false;
}
